export const authEn = {
  auth: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    password_confirm: 'Confirm Password',
    forgot_password: 'Forgot Password?',
    reset_password: 'Reset Password',
    change_password: 'Change Password',
    remember_me: 'Remember me',
    login_success: 'Logged in successfully',
    logout_success: 'Logged out successfully',
    register_success: 'Registration successful. Please check your email to verify your account.',
    verify_email_required: 'You need to verify your email before continuing.',
    invalid_credentials: 'Invalid email or password',
    already_have_account: 'Already have an account?',
    dont_have_account: 'Don\'t have an account?',
    sign_in: 'Sign in',
    sign_up: 'Sign up',
    sign_in_to_account: 'Sign in to your account',
    create_account: 'Create a new account',
    current_password: 'Current Password',
    new_password: 'New Password',
    new_password_confirm: 'Confirm New Password',
    password_changed: 'Password changed successfully',
    reset_link_sent: 'Password reset link has been sent to your email',
    send_reset_link: 'Send Reset Link',
    back_to_login: 'Back to Login',
    reset_token: 'Reset Token',
    reset_code: 'Reset Code',
    email_placeholder: 'Your e-mail address',
    password_requirements: 'Password must be at least 8 characters long',
    token_placeholder: 'Enter the token from your email',
    enter_new_password: 'Enter your new password',
    login_with_google: 'Continue with Google',
    links: {
      or_create_account: 'Or create a new account',
      create_new_account: 'Create new account',
      or_sign_in: 'Already have an account?',
      sign_in_existing: 'Sign in to existing account',
    },
    official_form: {
      title: 'Sign in',
      description: 'Enter your email and password to access your account',
      forgot_password_link: 'Forgot password?',
      logging_in: 'Signing in...',
      login_with_google: 'Continue with Google',
      no_account: "Don't have an account?",
      sign_up_link: 'Sign up',
    },
    form: {
      name: 'Full Name',
      name_placeholder: 'Enter your full name',
      email_placeholder: 'Enter your email',
      password_placeholder: 'Enter your password',
      password_confirm_placeholder: 'Confirm your password',
      current_password_placeholder: 'Enter your current password',
      new_password_placeholder: 'Enter your new password',
      new_password_confirm_placeholder: 'Confirm your new password',
      submit_login: 'Sign in',
      submit_register: 'Create account',
      submit_reset: 'Send reset link',
      submit_reset_password: 'Reset Password',
      submit_change_password: 'Change Password',
    },
    forgot_password_page: {
      title: 'Forgot your password?',
      subtitle: 'Enter your email address and we will send you a link to reset your password.',
      back_to_login: 'Back to login',
    },
    reset_password_page: {
      title: 'Set New Password',
      subtitle: 'Enter your new password below',
      back_to_login: 'Back to Login',
    },
    accept_invite_page: {
      title: 'Set Up Your Account',
      subtitle: 'Set a password below to activate your account.',
      submit_button: 'Activate Account',
      success: 'Your account has been activated. Redirecting to login...',
      invalid_or_expired: 'This invitation link is invalid or has expired. Ask whoever invited you to send a new one.',
      back_to_login: 'Back to Login',
    },
    change_password_page: {
      title: 'Change Password',
      subtitle: 'Update your account password',
    },
    two_factor: {
      title: 'Two-Factor Authentication',
      subtitle: 'Add an extra layer of security to your account',
      verification_success: 'Verification successful',
      verify_button: 'Verify',
      no_methods_configured: 'No 2FA methods configured',
      setup: {
        title: 'Two-Factor Authentication Setup',
      },
      verify: {
        title: 'Two-Factor Authentication',
      },
      totp: {
        title: 'Authenticator App (TOTP)',
        tab_label: 'Authenticator',
        description: 'Use an authenticator app like Google Authenticator or Authy',
        setup: 'Set up Authenticator',
        cancel: 'Cancel',
        disable: 'Disable TOTP',
        disable_confirm: 'Are you sure you want to disable TOTP authentication?',
        disable_success: 'TOTP authentication has been disabled',
        enabled: 'TOTP Authentication Enabled',
        enabled_description: 'Your authenticator app is set up and active',
        disabled: 'TOTP is disabled',
        scan_qr_code: 'Scan QR Code',
        scan_qr_code_description: 'Scan this QR code with your authenticator app',
        manual_entry: 'Or enter the code manually:',
        copy_secret: 'Copy secret',
        secret_copied: 'Secret copied to clipboard',
        scan_instructions: 'Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.)',
        scan_step_title: 'Step 1: Scan QR Code',
        scan_step_description: 'Use your authenticator app to scan the QR code below',
        continue_to_verify: 'Continue to Verification',
        verify_step_title: 'Step 2: Verify Code',
        verify_step_description: 'Enter the 6-digit code from your authenticator app',
        code_label: '6-digit code',
        code_placeholder: '000000',
        verify_button: 'Verify and Enable',
        setup_complete: 'TOTP Setup Complete',
        setup_success: 'TOTP authentication enabled successfully',
        backup_codes: 'Backup Codes',
        backup_codes_description: 'Save these backup codes in a safe place. You can use them to access your account if you lose your device.',
        backup_codes_warning: 'Each backup code can only be used once. Store them securely.',
        invalid_code: 'Invalid code. Please try again.',
        enter_code_help: 'Enter the 6-digit code from your authenticator app',
      },
      webauthn: {
        title: 'Passkeys',
        tab_label: 'Passkeys',
        description: 'Use biometric authentication or security keys',
        register: 'Register Passkey',
        register_title: 'Add New Passkey',
        register_description: 'Register a new passkey using your device\'s biometric authentication or security key',
        register_success: 'Passkey registered successfully',
        verify: 'Use Passkey',
        verify_instruction: 'Click the button below to authenticate with your passkey',
        passkey_name: 'Passkey Name',
        passkey_name_placeholder: 'e.g., iPhone, Laptop, YubiKey',
        passkey_name_help: 'Give your passkey a memorable name to identify it later',
        no_passkeys: 'No passkeys registered',
        registered_passkeys: 'Registered Passkeys',
        passkeys_description: 'Manage your registered passkeys',
        last_used: 'Last Used',
        created: 'Created',
        name: 'Name',
        delete: 'Delete',
        delete_confirm: 'Are you sure you want to delete this passkey?',
        delete_success: 'Passkey deleted successfully',
        add_passkey: 'Add New Passkey',
        user_cancelled: 'Authentication cancelled',
        not_supported: 'Passkeys are not supported on this device',
      },
      verify_page: {
        title: 'Verify Your Identity',
        subtitle: 'Please verify using one of your 2FA methods',
        choose_method: 'Choose verification method',
      },
    },
    verify_email: {
      title: 'Confirm your email address',
      subtitle: 'Complete the verification process to unlock all features.',
      instructions: 'We have sent a verification link to your email. Click the link in the message to confirm your account.',
      resend_label: 'Didn\'t get the email? Resend the verification link.',
      resend_helper: 'We will send a new verification email to this address.',
      resend_button: 'Resend verification email',
      back_to_login: 'Return to login',
      go_to_app: 'Go to dashboard',
      email_required: 'Email address is required to resend the verification link.',
      invalid_or_expired: 'Verification link is invalid or has expired. Request a new one below.',
      success: 'Email address verified successfully.',
      redirecting_to_dashboard: 'Redirecting to dashboard...',
      redirecting_to_login: 'Redirecting to login...',
    },
    pages: {
      login: 'Sign In',
      register: 'Sign Up',
      verifyEmail: 'Verify Email',
      acceptInvite: 'Accept Invitation',
      oauthCallback: 'OAuth Callback',
    },
    oauth: {
      button: {
        continue_with_google: 'Google',
        continue_with_facebook: 'Facebook',
        continue_with_github: 'GitHub',
        redirecting: 'Redirecting...',
      },
      or_continue_with: 'Or continue with',
      callback: {
        signing_in: 'Signing you in...',
        processing: 'Processing your {provider} authentication. Please wait...',
        authentication_failed: 'Authentication Failed',
        cancelled_or_denied: 'OAuth authentication was cancelled or denied',
        invalid_parameters: 'Invalid OAuth parameters',
        invalid_state: 'Invalid state parameter - possible CSRF attack',
        failed: 'OAuth authentication failed',
        success: 'Successfully signed in with {provider}',
        two_factor_required: 'Two-factor authentication required',
        not_configured: 'Google OAuth not configured',
        failed_to_initiate: 'Failed to initiate login',
      },
    },
  },
}
